import { query } from 'atomic-layout';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { ParagraphSize } from '@/types/styles';

import Box, { IBox } from './Box';

interface IStyledParagraph extends IBox {
  size?: ParagraphSize;
  sizeDownMd?: ParagraphSize;
}

const paragraphStyle: Record<ParagraphSize, FlattenSimpleInterpolation> = {
  small: css`
    font-size: 14px;
    line-height: 20px;
  `,
  normal: css`
    font-size: 16px;
    line-height: 24px;
  `,
  medium: css`
    font-size: 18px;
    line-height: 26px;
  `,
  large: css`
    font-size: 20px;
    line-height: 30px;
  `,
  larger: css`
    font-size: 24px;
    line-height: 32px;
  `,
};
const StyledParagraph = styled(Box)<IStyledParagraph>`
  margin: 0;

  ${({ size = 'normal' }) => paragraphStyle[size as ParagraphSize]};

  ${({ sizeDownMd }) =>
    sizeDownMd &&
    css`
      @media ${query({ to: 'md' })} {
        ${paragraphStyle[sizeDownMd as ParagraphSize]}
      }
    `};
`;

const Paragraph: React.FC<IStyledParagraph> = props => (
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  <StyledParagraph as="div" {...props} />
);

export default Paragraph;
